import { useFormContext } from 'react-hook-form';
import { Grid, TextField } from '@mui/material';
import WSTextField, { TextType } from '../../../Components/TextBox/WSTextBox';
import WSFileUpload from '../../../Components/FileUpload/WSFileUpload';

export const Step7SkillsAssets = () => {
  const { control } = useFormContext();
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {/* <TextField label="Skills (Comma Separated)" fullWidth {...register('skills')} /> */}
        <WSTextField id="skills" label={"Skills (Comma Separated)"} control={control} name='skills' />
      </Grid>
      <Grid item xs={12}>
        {/* <TextField label="Certifications (Comma Separated)" fullWidth {...register('certifications')} /> */}
        <WSTextField id="certifications" label={"Certifications (Comma Separated)"} control={control} name='certifications' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Total Experience (Years)" fullWidth {...register('experience.totalYears')} /> */}
        <WSTextField id="experience.totalYears" type={TextType.AllowOnlyNumber} label={"Total Experience (Years)"} control={control} name='experience.totalYears' />
      </Grid>
      <Grid item xs={12} sm={6}>
        {/* <TextField label="Relevant Experience (Years)" fullWidth {...register('experience.relevantYears')} /> */}
        <WSTextField id="experience.relevantYears" type={TextType.AllowOnlyNumber} label={"Relevant Experience (Years)"} control={control} name='experience.relevantYears' />
      </Grid>
      <Grid item xs={12}>
        {/* <TextField label="Laptop Serial No" fullWidth {...register('laptopSerial')} /> */}
        <WSTextField id="laptopSerial" label={"Laptop Serial No"} control={control} name='laptopSerial' />
      </Grid>
      <Grid item xs={12}>
        {/* <TextField label="VPN Installed (true/false)" fullWidth {...register('vpnInstalled')} /> */}
        <WSTextField id="vpnInstalled" label={"VPN Installed (true/false)"} control={control} name='vpnInstalled' />
      </Grid>
      {/* <Grid item xs={12}>
        <WSFileUpload
        id="offerLetter"
          name="offerLetter"
          label="Upload Offer Letter"
          acceptFileTypes='.pdf,.doc,.docx'
          control={control}
        />
      </Grid> */}
    </Grid>
  );
};